import { useState } from 'react'

import { IconChevron } from '../../Icon'
import {
  NAV_ARROWS_DIRECTIONS,
  NavArrowButton,
  NavArrows,
} from '../../NavArrow'
import { Container } from '../Container'

import { SIZES } from './NavArrows.constants'

import * as styles from '../Tables/Pagination/PageInput.module.css'

function Spin() {
  const [value, setValue] = useState(0)

  return (
    <>
      <Container
        label={`ChevronIcon: direction=${JSON.stringify(NAV_ARROWS_DIRECTIONS)}`}
      >
        {NAV_ARROWS_DIRECTIONS.map(direction => (
          <IconChevron
            direction={direction}
            key={direction}
            style={{ width: 40 }}
          />
        ))}
      </Container>

      <Container
        label={`NavArrowButton: direction=${JSON.stringify(NAV_ARROWS_DIRECTIONS)}`}
      >
        {NAV_ARROWS_DIRECTIONS.map(direction => (
          <NavArrowButton direction={direction} key={direction} />
        ))}
      </Container>

      <Container label={`NavArrows: size=${JSON.stringify(SIZES)}`}>
        {SIZES.map(size => (
          <NavArrows key={size} size={size} value={value} onChange={setValue} />
        ))}
      </Container>

      <div className={styles.output}>
        Value: {JSON.stringify(value, null, 4)}
      </div>
    </>
  )
}

export default Spin
